import { render } from "./Testimonials.vue?vue&type=template&id=db01bc24"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=db01bc24&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__